(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["core-media-gallery"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('core-media-gallery')) return;

  const DESKTOP = window.matchMedia('(min-width: 990px)');
  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  const designMode = () => Boolean(window.Shopify && window.Shopify.designMode);

  class CoreMediaGallery extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.ac = new AbortController();
      this.sig = { signal: this.ac.signal };
      this.track = this.querySelector('[data-track]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.thumbsWrap = this.querySelector('[data-thumbs]');
      this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
      this.counter = this.querySelector('[data-counter]');
      this.progress = this.querySelector('[data-progress]');
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');
      this.index = 0;
      this.lastIndex = -1;

      this.mount();
      this.bindNav();
      this.bindVideos();
      this.bindColorSync();
      this.bindLightbox();
      this.bindEditor();
      requestAnimationFrame(() => this.update());
    }

    disconnectedCallback() {
      queueMicrotask(() => { if (!this.isConnected && this.ac) this.ac.abort(); });
    }

    mount() {
      const sel = this.dataset.replaceTarget;
      if (sel) {
        let target = null;
        try { target = document.querySelector(sel); } catch (e) { target = null; }
        if (target && !target.contains(this)) {
          target.querySelectorAll('core-media-gallery').forEach((el) => {
            if (el !== this && el.dataset.sectionId === this.dataset.sectionId) el.remove();
          });
          target.prepend(this);
        }
      }
      this.classList.add('is-mounted');
    }

    isGrid() {
      return this.classList.contains('cmg--desktop-grid') && DESKTOP.matches;
    }

    visible() {
      return this.slides.filter((s) => !s.hidden && s.offsetParent !== null);
    }

    currentIndex(vis) {
      if (this.isGrid()) return Math.min(this.index, vis.length - 1);
      const x = this.track.scrollLeft;
      if (x > 0 && x >= this.track.scrollWidth - this.track.clientWidth - 2) return vis.length - 1;
      let best = 0;
      let dist = Infinity;
      vis.forEach((s, i) => {
        const d = Math.abs(s.offsetLeft - x);
        if (d < dist) { dist = d; best = i; }
      });
      return best;
    }

    goTo(i, smooth = true) {
      const vis = this.visible();
      if (!vis.length) return;
      i = Math.max(0, Math.min(i, vis.length - 1));
      this.index = i;
      const behavior = smooth && !REDUCED.matches ? 'smooth' : 'auto';
      if (this.isGrid()) vis[i].scrollIntoView({ behavior, block: 'center' });
      else this.track.scrollTo({ left: vis[i].offsetLeft, behavior });
      this.update();
    }

    update() {
      const vis = this.visible();
      const n = vis.length;
      this.classList.toggle('cmg--single', n < 2);
      if (!n) return;
      const i = this.currentIndex(vis);
      this.index = i;
      if (this.counter) this.counter.textContent = `${i + 1} / ${n}`;
      if (this.progress) this.progress.style.width = `${((i + 1) / n) * 100}%`;
      if (this.prevBtn) this.prevBtn.disabled = i === 0;
      if (this.nextBtn) this.nextBtn.disabled = i === n - 1;
      if (i === this.lastIndex) return;
      this.lastIndex = i;
      const activeId = vis[i].dataset.blockId;
      this.thumbs.forEach((t) => {
        const on = t.dataset.blockId === activeId;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
        if (on && this.thumbsWrap && this.thumbsWrap.offsetParent !== null) {
          this.thumbsWrap.scrollTo({
            left: t.offsetLeft - (this.thumbsWrap.clientWidth - t.offsetWidth) / 2,
            behavior: 'smooth',
          });
        }
      });
    }

    bindNav() {
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this._raf);
        this._raf = requestAnimationFrame(() => this.update());
      }, { passive: true, ...this.sig });

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.goTo(this.index - 1), this.sig);
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.goTo(this.index + 1), this.sig);

      this.thumbs.forEach((t) => {
        t.addEventListener('click', () => {
          const i = this.visible().findIndex((s) => s.dataset.blockId === t.dataset.blockId);
          if (i > -1) this.goTo(i);
        }, this.sig);
      });

      this.track.addEventListener('keydown', (e) => {
        if (this.isGrid()) return;
        if (e.key === 'ArrowRight') { e.preventDefault(); this.goTo(this.index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.goTo(this.index - 1); }
      }, this.sig);

      DESKTOP.addEventListener('change', () => { this.lastIndex = -1; this.goTo(0, false); }, this.sig);
    }

    bindVideos() {
      this.slides.forEach((slide) => {
        const v = slide.querySelector('video');
        if (!v) return;
        const play = slide.querySelector('[data-play]');
        const sound = slide.querySelector('[data-sound]');
        const sync = () => {
          if (!play) return;
          play.classList.toggle('is-playing', !v.paused);
          play.setAttribute('aria-label', v.paused ? 'Play video' : 'Pause video');
        };
        v.addEventListener('play', sync, this.sig);
        v.addEventListener('pause', sync, this.sig);

        if (play) {
          play.addEventListener('click', (e) => {
            e.stopPropagation();
            if (v.paused) v.play().catch(() => {}); else v.pause();
          }, this.sig);
        }
        if (sound) {
          sound.addEventListener('click', (e) => {
            e.stopPropagation();
            v.muted = !v.muted;
            sound.classList.toggle('is-on', !v.muted);
            sound.setAttribute('aria-pressed', String(!v.muted));
            sound.setAttribute('aria-label', v.muted ? 'Turn sound on' : 'Turn sound off');
            if (!v.muted && v.paused) v.play().catch(() => {});
          }, this.sig);
        }
      });

      const auto = this.slides
        .map((s) => s.querySelector('video[data-autoplay="true"]'))
        .filter(Boolean);
      if (!auto.length || !('IntersectionObserver' in window)) return;

      const io = new IntersectionObserver((entries) => {
        entries.forEach(({ target: v, isIntersecting, intersectionRatio }) => {
          if (isIntersecting && intersectionRatio >= 0.6 && !REDUCED.matches) {
            if (v.preload === 'none') v.preload = 'metadata';
            v.play().catch(() => v.closest('[data-slide]').classList.add('needs-tap'));
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { threshold: [0, 0.6] });
      auto.forEach((v) => io.observe(v));
      this.ac.signal.addEventListener('abort', () => io.disconnect());
    }

    bindColorSync() {
      if (!this.hasAttribute('data-filter-color')) return;
      const keys = [...new Set(this.slides.map((s) => s.dataset.color).filter(Boolean))];
      if (!keys.length) return;

      const match = (val) => {
        if (!val) return null;
        const v = String(val).toLowerCase().trim();
        return keys.find((k) => v === k || v.includes(k)) || null;
      };
      const fromEl = (el) => match(el.value) || match(el.selectedOptions && el.selectedOptions[0] && el.selectedOptions[0].textContent);

      document.addEventListener('change', (e) => {
        const t = e.target;
        if (!t.matches || !t.matches('input[type="radio"], select')) return;
        const k = fromEl(t);
        if (k) this.filterColor(k);
      }, this.sig);

      const onVariant = (e) => {
        const variant = e.detail && (e.detail.variant || e.detail.selectedVariant);
        if (!variant || !variant.options) return;
        for (const o of variant.options) {
          const k = match(o);
          if (k) { this.filterColor(k); return; }
        }
      };
      document.addEventListener('variant:change', onVariant, { capture: true, ...this.sig });
      document.addEventListener('variant:changed', onVariant, { capture: true, ...this.sig });

      if (designMode()) return;
      for (const el of document.querySelectorAll('input[type="radio"]:checked, select')) {
        const k = fromEl(el);
        if (k) { this.filterColor(k); break; }
      }
    }

    filterColor(key) {
      if (this._color === key) return;
      this._color = key;
      const hide = (el) => Boolean(el.dataset.color) && el.dataset.color !== key;
      this.slides.forEach((s) => { s.hidden = hide(s); });
      this.thumbs.forEach((t) => { t.hidden = hide(t); });
      this.lastIndex = -1;
      this.index = 0;
      if (!this.isGrid()) this.track.scrollTo({ left: 0 });
      this.update();
    }

    clearFilter() {
      this._color = null;
      this.slides.forEach((s) => { s.hidden = false; });
      this.thumbs.forEach((t) => { t.hidden = false; });
      this.lastIndex = -1;
      this.update();
    }

    bindLightbox() {
      this.lb = this.querySelector('[data-lb]');
      if (!this.lb || typeof this.lb.showModal !== 'function') return;
      this.lbStage = this.lb.querySelector('[data-lb-stage]');
      this.lbCounter = this.lb.querySelector('[data-lb-counter]');

      this.track.addEventListener('click', (e) => {
        if (designMode() || e.target.closest('button')) return;
        const s = e.target.closest('[data-slide]');
        if (!s) return;
        const i = this.visible().indexOf(s);
        if (i > -1) this.openLb(i);
      }, this.sig);

      const q = (sel) => this.lb.querySelector(sel);
      q('[data-lb-close]').addEventListener('click', () => this.lb.close(), this.sig);
      if (q('[data-lb-prev]')) q('[data-lb-prev]').addEventListener('click', () => this.renderLb(this.lbIndex - 1), this.sig);
      if (q('[data-lb-next]')) q('[data-lb-next]').addEventListener('click', () => this.renderLb(this.lbIndex + 1), this.sig);

      this.lb.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') this.renderLb(this.lbIndex + 1);
        if (e.key === 'ArrowLeft') this.renderLb(this.lbIndex - 1);
      }, this.sig);

      let x0 = null;
      this.lbStage.addEventListener('pointerdown', (e) => { x0 = e.clientX; }, this.sig);
      this.lbStage.addEventListener('pointerup', (e) => {
        if (x0 === null) return;
        const dx = e.clientX - x0;
        x0 = null;
        if (Math.abs(dx) > 50) this.renderLb(this.lbIndex + (dx < 0 ? 1 : -1));
      }, this.sig);

      this.lb.addEventListener('close', () => {
        this.lbStage.innerHTML = '';
        document.documentElement.style.overflow = '';
        this.goTo(this.lbIndex, false);
      }, this.sig);
    }

    openLb(i) {
      this.renderLb(i);
      this.lb.showModal();
      document.documentElement.style.overflow = 'hidden';
    }

    renderLb(i) {
      const vis = this.visible();
      const n = vis.length;
      if (!n) return;
      i = ((i % n) + n) % n;
      this.lbIndex = i;
      const slide = vis[i];
      this.lbStage.innerHTML = '';
      const v = slide.querySelector('video');
      if (v) {
        const c = v.cloneNode(true);
        c.removeAttribute('class');
        c.removeAttribute('data-autoplay');
        c.controls = true;
        c.muted = true;
        c.preload = 'auto';
        this.lbStage.append(c);
        c.play().catch(() => {});
      } else {
        const src = slide.querySelector('img');
        if (!src) return;
        const img = new Image();
        img.src = slide.dataset.zoom || src.currentSrc || src.src;
        img.alt = src.alt || '';
        img.draggable = false;
        this.lbStage.append(img);
      }
      if (this.lbCounter) this.lbCounter.textContent = `${i + 1} / ${n}`;
    }

    bindEditor() {
      if (!designMode()) return;
      document.addEventListener('shopify:block:select', (e) => {
        const s = this.slides.find((x) => x.dataset.blockId === e.detail.blockId);
        if (!s) return;
        if (s.hidden) this.clearFilter();
        const i = this.visible().indexOf(s);
        if (i > -1) this.goTo(i, false);
      }, this.sig);
    }
  }

  customElements.define('core-media-gallery', CoreMediaGallery);
})();

  } catch(e) { console.error(e); }
})();
})();
